import { get } from 'lodash';
export const UTMFields = search => {
  if (!window) return;
  let object = {};
  const string = search || get(window, 'location.search', '');
  const params = new URLSearchParams(string);
  const qs = ["utm_source", "utm_medium", "utm_campaign"];
  qs.forEach(q => {
    if (params.get(q)) {
      object[q] = params.get(q);
    }
  });
  return object;
};